/* Quiz HD — recomendador por puntuación.

   Respuestas: P1 (goal) suma w_goal si el producto lo declara en
   quiz_goals. P2 (dieta) es FILTRO DURO: si el token no es "any" y el
   producto no lo declara en quiz_diet, queda descartado — una
   restricción dietética no se "compensa" con puntos. P3 (contexto)
   suma w_context vía quiz_context. Empates: bestseller primero.

   Los productos llegan en un JSON generado por Liquid con sus tokens
   ya resueltos desde metacampos. */

if (!customElements.get('quiz-hd')) {
  customElements.define('quiz-hd', class extends HTMLElement {
    connectedCallback() {
      this.steps = this.querySelectorAll('.hd-quiz__step');
      this.dots = this.querySelectorAll('.hd-quiz__dot');
      this.cardsEl = this.querySelector('[data-quiz-cards]');
      this.addBtn = this.querySelector('[data-quiz-add]');
      this.answers = {};
      this.picked = [];

      try {
        const raw = this.querySelector('[data-quiz-products]');
        this.products = raw ? JSON.parse(raw.textContent) : [];
      } catch (e) {
        this.products = [];
        console.error('[QuizHD] JSON de productos inválido', e);
      }
      // Tokens CSV -> arrays una sola vez.
      this.products.forEach(p => {
        p.goals = (p.goals || '').split(',').map(s => s.trim()).filter(Boolean);
        p.diet = (p.diet || '').split(',').map(s => s.trim()).filter(Boolean);
        p.context = (p.context || '').split(',').map(s => s.trim()).filter(Boolean);
      });

      this.wGoal = parseInt(this.dataset.wGoal, 10) || 3;
      this.wContext = parseInt(this.dataset.wContext, 10) || 1;
      this.max = parseInt(this.dataset.max, 10) || 3;

      this.addEventListener('click', (e) => {
        const opt = e.target.closest('.hd-quiz__opt');
        if (opt) {
          this.answers[opt.dataset.qstep] = (opt.dataset.value || '').toLowerCase();
          if (opt.dataset.next === 'result') this.renderResult();
          this.show(opt.dataset.next);
          return;
        }
        if (e.target.closest('[data-restart]')) {
          this.answers = {};
          this.show('1');
          return;
        }
        if (e.target.closest('[data-quiz-add]')) this.addAll();
      });
    }

    show(id) {
      this.steps.forEach(s =>
        s.classList.toggle('is-active', s.dataset.step === id));
      const cur = id === 'result' ? 4 : parseInt(id, 10);
      this.dots.forEach(d =>
        d.classList.toggle('is-on', parseInt(d.dataset.dot, 10) <= cur));
    }

    score() {
      const goal = this.answers['1'] || 'any';
      const diet = this.answers['2'] || 'any';
      const ctx = this.answers['3'] || 'any';

      return this.products
        .filter(p => p.available)
        // Filtro duro de dieta: sin token declarado, fuera.
        .filter(p => diet === 'any' || p.diet.includes(diet))
        .map(p => {
          let pts = 0;
          if (goal !== 'any' && p.goals.includes(goal)) pts += this.wGoal;
          if (ctx !== 'any' && p.context.includes(ctx)) pts += this.wContext;
          if (p.bestseller) pts += 0.5; // desempate, nunca decisivo
          return { p, pts };
        })
        .sort((a, b) => b.pts - a.pts)
        .slice(0, this.max)
        // Nunca recomendar productos con 0 relevancia real (solo
        // pasaron el filtro): mejor 2 acertados que 3 de relleno.
        .filter((x, i) => x.pts >= 1 || i === 0)
        .map(x => x.p);
    }

    renderResult() {
      this.picked = this.score();
      if (!this.cardsEl) return;

      if (!this.picked.length) {
        this.cardsEl.innerHTML = '<p class="hd-quiz__nomatch">' +
          (this.cardsEl.dataset.tplNomatch || 'No exact match — browse all supplements.') + '</p>';
        if (this.addBtn) this.addBtn.hidden = true;
        return;
      }
      if (this.addBtn) this.addBtn.hidden = false;

      this.cardsEl.innerHTML = this.picked.map(p =>
        '<a class="hd-quiz__card" href="' + p.url + '">' +
          (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" width="72" height="72">' : '') +
          '<span class="hd-quiz__card-meta">' +
            '<strong>' + this.esc(p.title) + '</strong>' +
            '<span class="hd-num">' + this.esc(p.priceFormatted) + '</span>' +
          '</span>' +
        '</a>'
      ).join('');
    }

    esc(s) {
      return String(s).replace(/[&<>"']/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[c]));
    }

    async addAll() {
      const items = this.picked
        .map(p => ({ id: p.variantId, quantity: 1 }))
        .filter(i => Number.isInteger(i.id));
      if (!items.length || !this.addBtn) return;

      const original = this.addBtn.textContent;
      this.addBtn.setAttribute('aria-disabled', 'true');
      try {
        if (window.HDCart && typeof window.HDCart.addItems === 'function') {
          await window.HDCart.addItems(items);
        } else {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!res.ok) throw new Error('add failed');
          const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(r => r.json());
          document.dispatchEvent(new CustomEvent('hd:cart:updated', { detail: { cart } }));
        }
        this.addBtn.textContent = this.addBtn.dataset.addedLabel || original;
      } catch (e) {
        console.error('[QuizHD]', e);
      } finally {
        setTimeout(() => {
          this.addBtn.textContent = original;
          this.addBtn.setAttribute('aria-disabled', 'false');
        }, 1600);
      }
    }
  });
}
